import Image from "next/image";
import React from "react";

export default function SocialComponent() {
    return (
        <div className="flex justify-start gap-5">
            <a href="https://www.facebook.com/30acker/"
               target="_blank"
               rel="noopener noreferrer"
               className="flex items-center justify-center">
                <Image
                    src='/icons/icon-social-facebook.svg'
                    alt='Facebook'
                    width={16}
                    height={16}
                />
            </a>
            <a href="https://instagram.com/dreissigacker?igshid=g3mqm7e5bnj"
               target="_blank"
               rel="noopener noreferrer"
               className="flex items-center justify-center">
                <Image
                    src='/icons/icon-social-instagram.svg'
                    alt='Instagram'
                    width={16}
                    height={16}
                />
            </a>
            <a href="https://www.youtube.com/channel/UCCKAfS-rSG11Y50ik1XNxgQ"
               target="_blank"
               rel="noopener noreferrer"
               className="flex items-center justify-center">
                <Image
                    src='/icons/icon-social-youtube.svg'
                    alt='Youtube'
                    width={16}
                    height={16}
                />
            </a>
            <a href="https://www.pinterest.de/jdreissigacker/"
               target="_blank"
               rel="noopener noreferrer"
               className="flex items-center justify-center">
                <Image
                    src='/icons/icon-social-pinterest.svg'
                    alt='Pinterest'
                    width={16}
                    height={16}
                />
            </a>
            <a href="https://www.linkedin.com/company/weingut-dreissigacker/"
               target="_blank"
               rel="noopener noreferrer"
               className="flex items-center justify-center">
                <Image
                    src='/icons/icon-social-linkedin.svg'
                    alt='Linkedin'
                    width={16}
                    height={16}
                />
            </a>
            <a href="https://wa.me/message/UA5TLI6BUV65B1"
               target="_blank"
               rel="noopener noreferrer"
               className="flex items-center justify-center">
                <Image
                    src='/icons/icon-social-whatsapp.svg'
                    alt='Whatsapp'
                    width={16}
                    height={16}
                />
            </a>
        </div>
    );
}